<template>
  <div class="main">
    <div class="header">
      <div>课程简介</div>
      <div @click="goback()">
        <Icon type="ios-redo-outline" />返回列表
      </div>
    </div>
    <div class="content">
      <div><img src="../../assets/images/exam.jpg" /></div>
      <div>
        <div class="content-title">课程名称：古典音乐</div>
        <div class="content-belong">
          <div>所属级别：高中英语</div>
          <div>所属科目：英语</div>
        </div>
        <div class="content-profile">
          <div>课程简介：</div>
          <div>
            （双语教学）采用的是斯蒂格利茨所编的教科书，主要内容包括混合经济中的公共部门、市场效率、市场失灵、效率与公平、公共商品、公共选择、公共生产与官僚机构、外部性与环境、支出政策分析、成本收益分析、保健、国防与技术、社会保险、收入再分配、税收导论、税收归宿、税收与经济效率、最适课税、资本课税、个人所得税、公司所得税、税制改革、财政联邦制、州和地方的税收与支出以及赤字财政，基本上包含了公共财政学中的所有主要内容。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
      }
    },
    components: {},
    computed: {},
    mounted() { },
    methods: {
      goback() {
        this.$router.push('/examinationBank')
      }
    }
  }
</script>
<style scoped lang="less">
  .main {
    padding: 20px;
    font-size: 20px;
    .header {
      display: flex;
      justify-content: space-between;
      height: 40px;
      margin-bottom: 20px;
      i {
        transform: rotateY(180deg)
      }
      div:nth-child(1) {
        border-bottom: 3px solid coral;
        height: 30px;
        font-size: 17px;
      }
      div:nth-child(2) {
        color: coral;
        margin-right: 30px;
        line-height: 60px;
        cursor: pointer;
      }
    }
    .content {
      display: flex;
      text-align: center;
      line-height: 35px;
      div:nth-child(1) {
        img {
          width: 240px;
          height: 170px;
        }
      }
      div:nth-child(2) {
        padding-left: 10px;
        .content-belong {
          display: flex;
          justify-content: space-evenly;
        }
        .content-profile {
          text-indent: 25px;
          text-align: left;
        }
      }
    }
  }
</style>
